/* eslint-disable no-case-declarations */
import * as types from '../action.types';

export const initialState = {
  lastInsertedId: 0,
  messages: [],
};

const MessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_MESSAGE:
      const newId = state.lastInsertedId + 1;

      return {
        lastInsertedId: newId,
        messages: [...state.messages, {
          id: newId,
          ...action.payload,
        }],
      };
    case types.DELETE_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter(message => message.id !== action.payload),
      };
    default:
      return state;
  }
};

export default MessageReducer;
